import { cloneElement } from 'react';
import Tooltip from '@mui/material/Tooltip';
import * as Constants from '../../constants';
import { currentUserWriteAccess } from '../../Utilities';

/**
 * Wraps a call-to-action that writes to the backend. Accounts without write access
 * still see the control, greyed out and explaining itself on hover, tap or focus.
 * Pointer events are dropped on the child so the tooltip can listen on the wrapper.
 *
 * Set nativeDisabled to false for children that are not form controls, such as MUI
 * icons, where `disabled` would end up on the DOM node as an invalid attribute.
 */
function WriteAccessGuard({ children, nativeDisabled = true, message = Constants.NO_WRITE_ACCESS_MESSAGE }) {
    if (currentUserWriteAccess()) {
        return children;
    }

    // Greying out is not enough on its own: a submit button still reacts to Enter
    // in a sibling field, and a switch still toggles from the keyboard
    const blockedProps = { onClick: undefined };
    if (nativeDisabled) {
        blockedProps.disabled = true;
    }

    return (
        <Tooltip title={message} arrow enterTouchDelay={0} leaveTouchDelay={4000}>
            <span className="no-write-access" aria-disabled="true">
                {cloneElement(children, blockedProps)}
            </span>
        </Tooltip>
    );
}

export default WriteAccessGuard;
